import { Modal } from 'react-bootstrap'
import React from 'react'

const UnavailableUserClientModal = ({
  users,
  clients,
  showModal,
  closeModal,
  unavailableClients,
  unavailableUsers
}) => {
  const handleConfirm = () => {
    closeModal(true)
  }

  const handleCancel = () => {
    closeModal(false)
  }

  const unavailableUsersList = () => {
    const userList = users.filter((u) => {
      return unavailableUsers.includes(u.uid)
    })
    return userList.map((user) => (
      <p style={{ margin: 0 }}> {`• ${user.uid} - ${user.full_name}`}</p>
    ))
  }

  const unavailableClientsList = () => {
    const clientsList = clients.filter((c) => {
      return unavailableClients.includes(c.value)
    })
    return clientsList.map((client) => (
      <p style={{ margin: 0 }}> {`• ${client.value} - ${client.label}`}</p>
    ))
  }

  return (
    <div>
      <Modal
        onHide={handleCancel}
        backdrop="static"
        keyboard={false}
        size="lg"
        show={showModal}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="title-grey-icon ">
              <b className="unavailable-modal-title"> Usuarios y/o clientes no disponibles</b>
            </p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px' }}>
          <div>
            <div className="container-fluid modal-container">
              <div className="form-row">
                <p>
                  El plan de visitas no pudo ser creado porque algunos de los usuarios y/o clientes
                  asignados actualmente no están disponibles. Por favor revise el listado y
                  elimínelos para continuar.
                </p>
              </div>
              {unavailableUsers.length > 0 && (
                <div className="form-row">
                  <p>
                    <b className="mb-20">Listado de usuario(s): </b>
                    <div className="mb-20" style={{ whiteSpace: 'pre-line' }}>
                      {unavailableUsersList()}
                    </div>
                  </p>
                </div>
              )}
              {unavailableClients.length > 0 && (
                <div className="form-row">
                  <p>
                    <b className="mb-20">Listado de cliente(s): </b>
                    <div className="mb-20" style={{ whiteSpace: 'pre-line' }}>
                      {unavailableClientsList()}
                    </div>
                  </p>
                </div>
              )}
              <br />
              <div className="form-group">
                <div className="check-modal-user d-flex align-items-center"></div>
                <div className="float-right mt-3">
                  <button onClick={handleCancel} className="btn float-right blue-modal-button">
                    Cerrar y revisar
                  </button>
                  <button onClick={handleConfirm} className="btn float-right red-modal-button">
                    Eliminar no activos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default UnavailableUserClientModal
